import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiElearnioLoaderComponent } from './ai-elearnio-loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AiElearnioLoaderComponent],
  exports: [AiElearnioLoaderComponent],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class AiElearnioLoaderModule {}
